module.exports = __webpack_public_path__ + "img/trophy-award.4518285a.gif";